import { styled } from '../../utils/styled';

export const BorderBoxContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`('border-box');

export const BorderBoxContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`('border-box-content');
